import { combineReducers } from 'redux';
import { routerReducer as routing } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';

import search from './search/reducer';
import info from './info/reducer';
import chat from './chat/reducer';
import auth from './auth/reducer';
import user from './user/reducer';
import mail from './mail/reducer';
import magazine from './magazine/reducer';
import lastTimeRefresh from './lastTimeRefresh/reducer';
import categories from './categories/reducer';
import topics from './topics/reducer';
import goals from './goals/reducer';
import journal from './journal/reducer';
import feedback from './feedback/reducer';
import comments from './comments/reducer';
import feed from './feed/reducer';
import f2f from './f2f/reducer';
import links from './links/reducer';
import forum from './forum/reducer';

export default combineReducers({
  form: formReducer,
  info,
  search,
  routing,
  chat,
  auth,
  mail,
  magazine,
  lastTimeRefresh,
  user,
  categories,
  topics,
  goals,
  journal,
  feedback,
  comments,
  feed,
  f2f,
  links,
  forum
});



/** WEBPACK FOOTER **
 ** ./src/members/state/reducer.js
 **/